export const wsLog = (...args) => {
  console.info('%c🚨WS:', 'font-weight:bold;color:orange', ...args);
};
